export const invoice = {
  invoice: {
    noInvoicesAvailable: 'No invoices available.',
    table: {
      header: {
        invoiceNumber: 'Invoice Number',
        invoiceDate: 'Invoice Date',
        grossAmount: 'Gross Amount',
        amountOwed: 'Amount Owed',
        poNumber: 'Po Number',
        dueDate: 'Due Date',
        paymentTerm: 'Payment Term',
        status: 'Status',
        creditAdj: 'Credit Adj',
        orderNumber: 'Order Number'
      },
    },
    form: {
			instructions: 'Use the fields below to search for invoices.',						
			invoiceDate: 'Invoice Date',
			showOnlyOpenInvoices: 'Show only open invoices',
    },
    details: {
      invoiceNumber: 'Invoice #',
      invoiceDate: 'Invoice Date',
      accountName: 'Account Name',
      invoiceTotal: 'Invoice Total',
      billTo: 'Bill To',
      shipTo: 'Ship To',
      remitTo: 'Remit To',
      invoicePricingSummary: 'Invoice Pricing Summary',
      lineTotal: 'Line Total:',
      shipping: 'Shipping',
      tax: 'Tax',
      total: 'Total',
      dueDate: 'Date Due',
      order: 'Order #',
      customerPO: 'Customer PO',
      paymentTerm: 'Payment Term',
      invoiceCurrency: 'Invoice Currency',
      salesPerson: 'Sales Person',
      dateShipped: 'Date Shipped',
      carrier: 'Carrier',
      trackingInfo: 'Pro / Tracking #',
      line: 'Line',
      qtyOrdered: 'QTY Ordered',
      qtyShipped: 'QTY Shipped',
      uom: 'UOM',
      part: 'Part #',
      catalog: 'Catalog #',
      customerPart: 'Customer Part #',
      netPrice: 'Net Price',
      extPrice: 'Ext Price',
      tariff: 'Tariff',
      poLineNumber: 'PO Line Number',
      noLinesAvailable: 'No lines available'
    }
  },
};
